import { ConfigParternship, ConfigParternshipLogo } from "@/types/configuration";
import { Image } from "@habacuscode/habacus_ui_component_library";

export const buildParternshipLogo = (logo: ConfigParternshipLogo, dateTimeCache: string | null) => {
    return (
        <Image
            className="object-contain self-center"
            showImageTitle={false}
            image={`${logo.url}?ts=${dateTimeCache ?? ''}`}
            alt={logo.name}
            link={logo.link ?? '#'}
            width={logo.logoSize ? `${logo.logoSize[0]}px` : "160px"}
            height={logo.logoSize ? `${logo.logoSize[1]}px` : "48px"}
        />
    );
};

export const retrieveParternshipLogo = (parternship: ConfigParternship, dateTimeCache: string | null) => {
    const { logo } = parternship;

    if (!logo) {
        return null;
    }

    if (typeof logo === 'string') {
        return buildParternshipLogo({
            name: parternship.name,
            url: logo,
            logoSize: parternship.logoSize,
            link: parternship.link,
        }, dateTimeCache);
    }

    return (
        <div className="flex justify-center gap-1.5">
            {logo.map((item, index) => (
                <div key={`${item.name}-${index}`} className="flex">
                    {buildParternshipLogo(item, dateTimeCache)}
                </div>
            ))}
        </div>
    );
};